<template>
  <div>
    <bita-breadcrumb :items="breadCrumbs" />
    <div class="wrapper wrapper-content animated fadeInRight">
      <bita-ibox :is-loading="isLoadingGrid">
        <div slot="body">
            <bita-grid
            ref="grid"
            :columns="gridColumns"
            :read-data="readData"
            :hasRow="false"
          />
        </div>
      </bita-ibox>
    </div>
    <form-modal
      ref="nativeModal"
      :isLoading="isLoadingModal"
      :props-data="formData"
      modal-id="native-modal"
      :title="title"
      @on-submit="handleEdit"
    />
  </div>
</template>
<script>
import formModal from "./components/NativeForm";

export default {
  components: { formModal },
  data() {
    return {
      breadCrumbs: [
        { title: "صفحه اصلی", link: "/" },
        {
          title: "مدیریت کاربران",
          link: "/",
        },
        {
          title: "مدیریت کاربران بومی ",
          link: "/management/native-driver",
          active: true,
        },
      ],
      title: "",
      isLoadingGrid: false,
      isLoadingModal: false,
      formData: {},
      gridColumns: [
        { title: "#", template: this.$getTemplate, width: "40px" },
        { field: "name", title: "نام" },
        {
          field: "loading_fee",
          title: "هزینه بارگیری",
          template: (e) =>
            e.loading_fee ? this.$currencyLabel(e.loading_fee) : "",
        },
        {
          field: "created_at",
          title: "تاریخ ایجاد",
          template: (e) =>
            e.created_at ? this.$getJalaliDateTime(e.created_at) : "",
        },
        {
          title: "عملیات",
          command: [],
        },
      ],
    };
  },
  computed: {},
  mounted() {
    this.loadData();
    this.gridColumns[this.gridColumns.length - 1].command = this.gridCommands();
  },
  methods: {
    readData(e) {
      this.$resetGrid();
      this.isLoadingGrid = true;
      this.$persistClient("get", "owners")
        .then((res) => {
          e.success(res.data);
        })
        .catch(() => {
          e.success([]);
        })
        .finally(() => {
          this.isLoadingGrid = false;
        });
    },
    loadData() {
      this.$refs.grid.loadDataSource();
    },
    gridCommands() {
      let commands = [];
      commands.push({
        text: "edit",
        click: this.edit,
        template: this.gridButtons.edit,
      });
      if ( this.$acl.isSuperAdmin )
        commands.push({
          text: "delete",
          click: this.delete,
          template: this.gridButtons.delete,
        });
      return commands;
    },
    edit(e) {
      this.isLoadingModal = true;
      let owner = this.$refs.grid.getSelectedGridRow(e);
      this.$refs.nativeModal.setData(owner)
      this.openNativeModal();
      this.isLoadingModal = false;
    },
    openNativeModal() {
      this.$toggleModal('#native-modal');
    },
    handleCreate(data) {
      //
    },
    handleEdit(data) {
      //
    },
  },
};
</script>

